import { useCallback, useEffect, useRef, useState } from 'react';
import { t } from 'react-switch-lang';
import { performSearch } from '../components/algolia/AlgoliaUtils';
import { setScreenReaderAlert } from './Accessibility';
import {
  events,
  trackGoogleAnalyticsEvent,
} from './GoogleAnalytics';

function useRelevantFAQSearch({ brand, lang, delay = 700 }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const suggestedArticleAlertRead = useRef(false);
  const relevantArticlesShownTracked = useRef(false);

  const handleTextareaChange = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  useEffect(() => {
    let active = true;

    async function updateSearchResults() {
      const results = await performSearch(searchTerm, brand, lang);
      if (!active) return;

      if (results.length > 0) {
        suggestedArticleAlertRead.current = true;
        if (!relevantArticlesShownTracked.current) {
          relevantArticlesShownTracked.current = true;
          trackGoogleAnalyticsEvent(events.CONTACT_RELEVANT_ARTICLES_SHOWN, {
            brand,
            language: lang,
            result_count: results.length,
            query_length: searchTerm.trim().length,
          });
        }
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_Suggested_Article', null, lang));
      } else if (suggestedArticleAlertRead.current) {
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_No_Suggested_Article', null, lang));
      }

      setSearchResults(results);
    }

    const timer = setTimeout(updateSearchResults, delay);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [brand, delay, lang, searchTerm]);

  return {
    clearSearch,
    handleTextareaChange,
    searchResults,
  };
}

export default useRelevantFAQSearch;
